export default __webpack_public_path__ + "_/_/node_modules/ui-header/src/images/lc-logo-white-7eeee78a968dfe9de32d19f6cc069a1b.png";